/* unplugin-vue-components disabled */import script from "./weblogin.vue?vue&type=script&setup=true&lang=ts"
export * from "./weblogin.vue?vue&type=script&setup=true&lang=ts"

import "./weblogin.vue?vue&type=style&index=0&id=3936ac59&scoped=true&lang=css"

import exportComponent from "D:\\openclawprogram\\sdjk123-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3936ac59"]])

export default __exports__